interface SizeProps {
  size?: number;
}

export function SkillVortex({ size = 40 }: SizeProps) {
  const gid = `vortex-g-${size}`;
  return (
    <svg viewBox="0 0 100 100" width={size} height={size}>
      <defs>
        <radialGradient id={gid} cx="50%" cy="50%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.9" />
          <stop offset="40%" stopColor="#9B5DE5" stopOpacity="1" />
          <stop offset="100%" stopColor="#9B5DE5" stopOpacity="0" />
        </radialGradient>
      </defs>
      <g style={{ transformOrigin: '50% 50%' }}>
        <path d="M 50 10 Q 90 50 50 90 Q 10 50 50 10 Z" fill={`url(#${gid})`} opacity="0.8" />
        <path d="M 50 25 Q 75 50 50 75 Q 25 50 50 25 Z" fill="#E63946" opacity="0.6" />
        <path d="M 50 35 Q 65 50 50 65 Q 35 50 50 35 Z" fill="#F4C724" opacity="0.7" />
        <circle cx="50" cy="50" r="6" fill="#fff" />
      </g>
    </svg>
  );
}

export function SkillShield({ size = 40 }: SizeProps) {
  const gid = `shield-g-${size}`;
  return (
    <svg viewBox="0 0 100 100" width={size} height={size}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#7eeaf7" />
          <stop offset="100%" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
      <polygon
        points="50,10 85,28 85,62 50,90 15,62 15,28"
        fill={`url(#${gid})`}
        stroke="#fff"
        strokeWidth="4"
        strokeLinejoin="round"
        opacity="0.95"
      />
      <polygon
        points="50,22 75,34 75,60 50,78 25,60 25,34"
        fill="none"
        stroke="rgba(255,255,255,0.5)"
        strokeWidth="2"
      />
      <path
        d="M 35 50 L 46 60 L 65 38"
        stroke="#fff"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
